var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import { Checkbox } from "@irati/ui/src/FormItem";
import idHelper from "@irati/utils/id";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import getTermsAndConditionsUrl from "@irati/deals/helpers/deals/getTermsAndConditionsUrl";
import Link from "@irati/ui/src/Link";
import { Body, H4 } from "@irati/ui/src/Typography";
import { TermsAndConditionsWrapper } from "./styled/TermsAndConditions";
var TermsAndConditions = function (_a) {
    var onChange = _a.onChange, termsAgreed = _a.termsAgreed, props = __rest(_a, ["onChange", "termsAgreed"]);
    var name = idHelper("checkbox", props);
    var _b = useState(undefined), termsLink = _b[0], setTermsLink = _b[1];
    useEffect(function () {
        getTermsAndConditionsUrl().then(function (url) {
            setTermsLink(url);
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(H4, { margin: [2, 0, 4] },
            React.createElement(FormattedMessage, { id: "perks.components.productForms.nonRefundablePayment.header" })),
        React.createElement(Body, null,
            React.createElement(FormattedMessage, { id: "perks.components.productForms.termsAndConditions.header" })),
        React.createElement(TermsAndConditionsWrapper, null,
            React.createElement(Checkbox, { name: name, onChange: onChange, checked: termsAgreed }),
            React.createElement("label", { htmlFor: name, id: idHelper("label", props) },
                React.createElement(FormattedMessage, { id: "perks.components.productForms.termsAndConditions.newBody", values: {
                        link: (React.createElement(Link, { cta: true, href: termsLink, target: "_blank" },
                            React.createElement(FormattedMessage, { id: "perks.components.productForms.termsAndConditions.link.text" })))
                    } })))));
};
TermsAndConditions.defaultProps = {
    id: "termsAndConditions",
    termsAgreed: false
};
export default injectIntl(TermsAndConditions);
